import { useTheme } from '@mui/material'
import React from 'react'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from 'recharts'

const QueryByTypeChart = ({ query_by_type = {} }: any) => {
  const theme = useTheme()
  // Transform the data for the chart
  const chartData = [
    {
      type: 'Text',
      count: query_by_type.text || 0,
      label: 'Text',
    },
    {
      type: 'Image',
      count: query_by_type.image || 0,
      label: 'Image\nQuery Type',
    },
    {
      type: 'Audio',
      count: query_by_type.audio || 0,
      label: 'Audio',
    },
  ]

  // Custom label component to show count above bars
  const CustomLabel = (props: any) => {
    const { x, y, width, value } = props
    return (
      <text x={x + width / 2} y={y - 5} fill="#666" textAnchor="middle" fontSize="12" fontWeight="500">
        {value}
      </text>
    )
  }

  return (
    <div className="w-full h-96 p-6 bg-white rounded-lg shadow-sm border border-gray-200">
      <h2 className="text-lg font-medium mb-6 text-gray-800 text-center">Query by Type</h2>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{
            top: 30,
            right: 30,
            left: -30,
            bottom: 40,
          }}
          barCategoryGap="25%"
        >
          <XAxis dataKey="type" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#666' }} interval={0} />
          <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#666' }} domain={[0, 'dataMax + 20']} />
          <Bar dataKey="count" radius={[4, 4, 0, 0]} label={<CustomLabel />}>
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={theme.palette.primary.main} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default QueryByTypeChart
